module.exports = __webpack_public_path__ + "static/media/retail.f28117f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pins/retail.svg
// module id = 1952
// module chunks = 0